import { Button } from '@/components/ui/button'
import { Input, InputProps } from '@/components/ui/input'
import { cn } from '@/services/utils/cn'
import { EyeIcon, EyeOffIcon } from 'lucide-react'
import { forwardRef, useState } from 'react'

const PasswordInput = forwardRef<HTMLInputElement, InputProps>(
  ({ className, ...props }, ref) => {
    const [showPassword, setShowPassword] = useState(false)

    const togglePasswordVisibility = () => {
      setShowPassword((show) => !show)
    }

    return (
      <div className="relative">
        <Input
          className={cn(className)}
          ref={ref}
          {...props}
          type={showPassword ? 'text' : 'password'}
        />
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className={cn(
            `absolute right-0 top-0 h-full rounded-l-none border border-l-0 border-input bg-background px-3 py-2`,
            className
          )}
          onClick={togglePasswordVisibility}
          tabIndex={-1}
        >
          {showPassword ? (
            <EyeIcon className="h-4 w-4" />
          ) : (
            <EyeOffIcon className="h-4 w-4" />
          )}
        </Button>
      </div>
    )
  }
)
PasswordInput.displayName = 'PasswordInput'

export { PasswordInput }
